import {
  List,
  ListItem,
  ListItemButton,
  ListItemAvatar,
  Typography,
  Avatar,
  Box,
  Tabs,
  Tab,
  Button,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { colors, radii } from "../../../../theme/designTokens";
import {
  getNotification,
  readSingleNotification,
  setPanel,
} from "../../../../reduxToolkit/features/adminPanel/notification";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { getCreated, getExactTime } from "../../../../hooks/getCreatedData";
import { useNavigate } from "react-router-dom";
import LoadingBox from "../../../../components/misc/Loading";
import EmptyStateAlert from "../../../../components/adminPanel/shared/EmptyStateAlert";
import {
  getDosages,
  getMedicines,
} from "../../../../reduxToolkit/features/adminPanel/medicine";
import { getAdmins } from "../../../../reduxToolkit/features/adminPanel/admin";
import { useRef } from "react";
import useLazyLoad from "../../../../hooks/useLazyLoad";
import { getAllCustomers } from "../../../../reduxToolkit/features/auth";

// Icons

export default function NotificationDlg({
  unreadNotifications,
  notifications,
  error,
  setNotificationDlg,
  adminUrl,
}) {
  // Ref
  const triggerRef = useRef();

  const [activeTab, setActiveTab] = useState("all");
  const [loading, setLoading] = useState(false);
  const [notiList, setNotiList] = useState([]);

  const [lang, setLang] = useState("");
  const [, setLangId] = useState("");

  // local Store
  const localData = JSON.parse(localStorage.getItem("adminLoginInfo"));
  const localLangData = JSON.parse(localStorage.getItem("lang"));

  // Store
  const { medicines, medVariants, dosages } = useSelector(
    (state) => state.medicine
  );
  const { langs, activeLang } = useSelector((state) => state.misc);

  const { admins } = useSelector((state) => state.admin);
  const { customers } = useSelector((state) => state.auth);

  // Functions
  const dispatch = useDispatch();

  const getDosageInfo = (dosageId, langCode) => {
    let dosageName = "";
    if (dosages && dosages.length > 0) {
      const dosageList = dosages.find((d) => d.lang === langCode);
      if (dosageList && dosageList.data) {
        const D = dosageList.data.find((d) =>
          langCode !== "en" ? d.dosageDetectorId : d.fixedDosageId === dosageId
        );
        if (D && D.dosageName) dosageName = D.dosageName;
      }
    }
    return dosageName;
  };

  const handleNotiTitle = (x) => {
    let str = "";
    if (x.change) {
      // Assigned Price
      if (
        x.change.title === "assigned-price" ||
        x.change.title === "unassigned-price" ||
        x.change.title === "cancel-price" ||
        x.change.title === "update-assigned-price" ||
        x.change.title === "prescription-upload" ||
        x.change.title === "prescription-change"
      ) {
        if (
          localLangData &&
          localLangData.langCode &&
          medicines &&
          medicines.length > 0
        ) {
          if (x.change.title === "assigned-price")
            str += "Assigned price successfully for  ";
          else if (x.change.title === "cancel-price")
            str += "Cancelled price request successfully for  ";
          else if (x.change.title === "update-assigned-price")
            str += "Updated price request successfully for  ";
          else if (x.change.title === "prescription-upload")
            str += "Prescription added for ";
          else if (x.change.title === "prescription-change")
            str += "Prescription updated for ";
          else str += "Unassigned price successfully for  ";

          const M = medicines.find((m) => m.lang === localLangData.langCode);
          if (M && M.data) {
            const Med = M.data.find(
              (med) =>
                (localLangData.langCode !== "en"
                  ? med.medicineDetectorId
                  : med.fixedMedicineId) === x.change.medId
            );
            if (Med) {
              str += Med.genericBrand || "";
              if (medVariants && medVariants.length > 0) {
                const V = medVariants.find(
                  (v) =>
                    (localLangData.langCode !== "en"
                      ? v.variantDetectorId
                      : v.fixedVariantId) === x.change.variantId
                );
                if (V) {
                  const dosageInfo = `(${getDosageInfo(
                    V.dosageForm,
                    localLangData.langCode
                  )}-${V.strength}-${V.packTypes})`;

                  str += dosageInfo || "";

                  if (admins && admins.length > 0 && x.change.creatorId) {
                    const A = admins.find((a) => a._id === x.change.creatorId);
                    if (A) str += " by " + (A.adminName || "");
                  }
                  if (
                    x.change.customerId &&
                    customers &&
                    customers.length > 0
                  ) {
                    const C = customers.find(
                      (c) => c._id === x.change.customerId
                    );
                    if (C)
                      str +=
                        " by " + (C.name || "") + " (" + (C.email || "") + ")";
                  }
                }
              }
            }
          }
        }
      }
    } else {
      str = x.title;
    }
    return str;
  };

  const handleReadAllNotification = () => {
    setLoading(true);
    const admin = { adminId: localData._id };
    notifications.forEach((x) => {
      if (!x.adminsWhoRead.includes(admin.adminId))
        dispatch(readSingleNotification({ id: x._id, adminId: admin.adminId }));
    });
    setTimeout(() => {
      setLoading(false);
      dispatch(getNotification());
    }, 1000);
  };

  const navigate = useNavigate();
  const handleNotiClick = (link, panel, searchValue, id) => {
    setLoading(true);
    dispatch(setPanel(""));
    // Read Notification
    const isNotificationRead = () => {
      return unreadNotifications.some((el) => {
        return el._id === id;
      });
    };
    if (isNotificationRead()) {
      dispatch(readSingleNotification({ id, adminId: localData._id }));
      setTimeout(() => {
        dispatch(getNotification());
      }, 100);
    }
    // Navigate
    setTimeout(() => {
      navigate(`/${adminUrl}/`);
    }, 500);
    setTimeout(() => {
      navigate(
        `/${adminUrl}/${link}${
          searchValue !== "" ? "?search=" + searchValue : ""
        }`
      );
      dispatch(setPanel(panel));
    }, 1000);
    setTimeout(() => {
      setNotificationDlg(false);
      setLoading(false);
    }, 2000);
  };

  // Handle lazy load
  const NUM_PER_PAGE = 13;
  const noti = (
    activeTab === "all" ? notifications : unreadNotifications
  ).slice(0, NUM_PER_PAGE);
  const TOTAL_PAGES =
    (activeTab === "all" ? notifications : unreadNotifications).length /
    NUM_PER_PAGE;

  const onGrabData = (currentPage) => {
    // Notifications are already fully loaded client-side (from the
    // getNotification thunk) — this just slices the next chunk, so
    // there's no real network wait to simulate here.
    return Promise.resolve().then(() => {
      const noti = activeTab === "all" ? notifications : unreadNotifications;
      return noti.slice(
        ((currentPage - 1) % TOTAL_PAGES) * NUM_PER_PAGE,
        NUM_PER_PAGE * (currentPage % TOTAL_PAGES)
      );
    });
  };

  const { data, loading: loadingNoti } = useLazyLoad({
    triggerRef,
    onGrabData,
  });

  useEffect(() => {
    if (
      data.length <=
      (activeTab === "all" ? notifications : unreadNotifications).length
    ) {
      if (data && data.length > 0) {
        setNotiList(data);
      } else setNotiList(noti);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  // Reset to the first page immediately on tab switch, instead of
  // showing whichever tab's page happened to be loaded last.
  useEffect(() => {
    setNotiList(
      (activeTab === "all" ? notifications : unreadNotifications).slice(
        0,
        NUM_PER_PAGE
      )
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  useEffect(() => {
    if (!(medicines && medicines.length > 0)) dispatch(getMedicines());
    if (!(dosages && dosages.length > 0)) dispatch(getDosages());
    if (!(admins && admins.length > 0)) dispatch(getAdmins());
    if (!(customers && customers.length > 0)) dispatch(getAllCustomers());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set Language
  useEffect(() => {
    if (activeLang && activeLang.langCode) {
      setLang(activeLang.langCode);
      setLangId(activeLang._id);
    } else {
      if (localLangData) {
        setLang(localLangData.langCode);
        setLangId(localLangData._id);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLang]);

  // translate

  const [langSettings, setLangSettings] = useState([]);
  const titleDashboard = "Dashboard Top Bar";

  useEffect(() => {
    if (langs && langs.length > 0 && lang !== "") {
      const L = langs.find((l) => l.langCode === lang);
      let arr = [];
      if (L && L.langSettings && L.langSettings.length > 0)
        arr = L.langSettings;
      else {
        const LEn = langs.find((l) => l.langCode === "en");
        if (LEn && LEn.langSettings && LEn.langSettings.length > 0)
          arr = LEn.langSettings;
      }
      const dashboard = arr.find((l) => l._title === titleDashboard);
      if (dashboard) setLangSettings(dashboard.data);
    }
  }, [lang, langs]);

  const translate = (String) => {
    let translation = "";
    const T = langSettings.find((ls) => ls.title === String);
    if (T && T.value) translation = T.value;
    else {
      let arr = [];
      if (langs && langs.length > 0 && lang !== "") {
        const LEn = langs.find((l) => l.langCode === "en");
        if (LEn && LEn.langSettings && LEn.langSettings.length > 0)
          arr = LEn.langSettings;
        const dashboard = arr.find((l) => l._title === titleDashboard);
        if (dashboard) {
          const T = dashboard.data.find((ls) => ls.title === String);
          if (T && T.value) translation = T.value;
        }
      }
    }
    return translation;
  };

  // Renders one notification row; shared between the All/Unread tabs so
  // the two lists stay visually identical.
  const renderNotiRow = (x, i, { withRef, disabled } = {}) => {
    const unread = !x.adminsWhoRead.includes(localData._id);
    return (
      <Fragment key={i}>
        <ListItem
          disablePadding
          ref={withRef ? triggerRef : undefined}
          sx={{ borderBottom: `1px solid ${colors.line}` }}
        >
          <ListItemButton
            onClick={() =>
              handleNotiClick(
                x.link || "administration",
                x.panel || "manage-admins",
                x.searchValue || "",
                x._id
              )
            }
            disabled={disabled}
            sx={{
              alignItems: "flex-start",
              gap: 1.25,
              py: 1.25,
              px: 2,
              bgcolor: unread ? colors.primaryLight : "transparent",
              "&:hover": { bgcolor: colors.paperTint },
            }}
          >
            <ListItemAvatar sx={{ minWidth: 0 }}>
              <Avatar
                sx={{
                  bgcolor: colors.white,
                  border: `1px solid ${colors.line}`,
                  width: 36,
                  height: 36,
                }}
              >
                <LazyLoadImage
                  effect="blur"
                  src={x.notificationImage}
                  alt={x.title}
                  style={{
                    width: 22,
                    height: 22,
                    objectFit: "contain",
                  }}
                />
              </Avatar>
            </ListItemAvatar>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: 13.5,
                  fontWeight: unread ? 700 : 500,
                  color: colors.ink,
                  lineHeight: 1.45,
                }}
              >
                {handleNotiTitle(x)}
              </Typography>
              <Typography sx={{ fontSize: 11.5, color: colors.ink3, mt: 0.25 }}>
                {getCreated(x.createdAt)} {getExactTime(x.createdAt)}
              </Typography>
            </Box>
            {unread && (
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  bgcolor: colors.accent,
                  mt: 0.75,
                  flexShrink: 0,
                }}
              />
            )}
          </ListItemButton>
        </ListItem>
      </Fragment>
    );
  };

  return (
    <Box
      sx={{
        width: { xs: "85vw", sm: 400 },
        maxHeight: "80vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {error ? (
        <Box sx={{ p: 2 }}>
          <EmptyStateAlert severity="error" message="Something Went Wrong" />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              bgcolor: colors.white,
              borderBottom: `1px solid ${colors.line}`,
            }}
          >
            <Tabs
              value={activeTab}
              onChange={(e, v) => setActiveTab(v)}
              variant="fullWidth"
              sx={{
                minHeight: 44,
                "& .MuiTab-root": {
                  minHeight: 44,
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: 13.5,
                  color: colors.ink3,
                },
                "& .Mui-selected": { color: `${colors.primary} !important` },
                "& .MuiTabs-indicator": {
                  bgcolor: colors.primary,
                  height: 3,
                  borderRadius: radii.full,
                },
              }}
            >
              <Tab
                value="all"
                label={`${translate("All")} (${notifications.length})`}
              />
              <Tab
                value="unread"
                label={`${translate("Unread")} (${unreadNotifications.length})`}
              />
            </Tabs>
          </Box>
          {/* Notifications */}
          <Box sx={{ overflowY: "auto", flex: 1 }}>
            {activeTab === "all" ? (
              loading ? (
                <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
                  <LoadingBox w={"100%"} />
                </Box>
              ) : notiList.length > 0 ? (
                <List dense disablePadding>
                  {notiList.map((x, i) =>
                    renderNotiRow(x, i, { withRef: true })
                  )}
                </List>
              ) : (
                <Box sx={{ p: 2 }}>
                  <EmptyStateAlert message="No notifications available" />
                </Box>
              )
            ) : notiList.length > 0 ? (
              <List dense disablePadding>
                {notiList.map((x, i) =>
                  renderNotiRow(x, i, { withRef: true, disabled: loadingNoti })
                )}
              </List>
            ) : (
              <Box sx={{ p: 2 }}>
                <EmptyStateAlert message="No Unread Notification" />
              </Box>
            )}
            {loadingNoti && (
              <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
                <LoadingBox w={"100%"} />
              </Box>
            )}
          </Box>
          {unreadNotifications.length > 0 && (
            <Box
              sx={{
                position: "sticky",
                bottom: 0,
                bgcolor: colors.white,
                borderTop: `1px solid ${colors.line}`,
                p: 1,
              }}
            >
              <Button
                fullWidth
                size="small"
                onClick={handleReadAllNotification}
                sx={{ color: colors.primary, fontWeight: 700 }}
              >
                {translate("Mark all read")}
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
}
